export default "<!-- <div *ngIf=\"opcionMenu === 0\"><app-home></app-home></div>\r\n<div *ngIf=\"opcionMenu === 1\"><app-maestros></app-maestros></div> -->\r\n"